const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

if (isIE) {
    const root = document.getElementById("root");

    if (root) {
        root.innerHTML = `
            <style>
                .browserupgrade {
                    background: #eaedf0;
                    color: #000;
                    font-family: "Titillium", -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
                    font-size 23px;
                    margin: auto;
                    max-width: 90%;
                    padding: 1em 0.5em;
                    width: 1000px;
                }

                h1 {
                    color: rgb(160, 50, 140);
                    margin: 0;
                    padding: 0;
                }
            </style>

            <div class="browserupgrade">
                <h1>Navigateur non supporté</h1>
                <p>Votre navigateur n'est pas supporté par cette application. Utilisez un navigateur plus récent, comme Mozilla Firefox, Google Chrome ou encore Microsoft Edge afin d'y accéder. Si besoin, vous pouvez accéder à la liste des navigateurs supportés et les télécharger depuis <a href="http://outdatedbrowser.com/fr">ce lien</a>.</p>
            </div>
        `;
    }
} else {
    import("./main").then(mod => mod.main());
}
